import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateHTMLComponent } from "../../templates/template-html/template-html.component";

@Component({
  selector: "app-prefix-koh",
  imports: [TemplateHTMLComponent],
  templateUrl: "./prefix-koh.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-koh.component.less",
})
export class PrefixKohComponent extends PrefixComponent<string> {
  public constructor() {
    super();
    this.post = false;
    this.characters = ALLOWED_CHARACTERS["koh"];
  }
}
